export default class DynamicInboundCallsService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.$q = $q;
    this.ngAuthSettings = ngAuthSettings;
  }

  getDynamicInboundCallsCampaignSettings(accountId, campaignId) {
    const url = `${this.#getBaseRTBUrl(accountId, campaignId)}`;
    return this.$http.get(url);
  }

  getDynamicInboundCallsPublisherSettings(accountId, campaignId, affiliateId) {
    const url = `${this.#getBaseRTBPublisherUrl(accountId, campaignId, affiliateId)}`;
    return this.$http.get(url);
  }

  
  getDynamicInboundCallsAllPublisherSettings(accountId, campaignId) {
    const url = `${this.#getBaseRTBPublisherUrl(accountId, campaignId)}`;
    return this.$http.get(url);
  }
  
  getAffiliateIdsByCampaign(accountId, campaignId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/campaigns/${campaignId}/InboundReferences`;
    return this.$http.get(url);
  }

  getDynamicInbondCallsUrlForAdminsAndAffiliates(accountId, campaignId, affiliateId) {
    const url = `${this.#getBaseRTBPublisherUrl(accountId, campaignId, affiliateId)}` + '/url';
    return this.$http.get(url);
  }

  getDynamicInbondCallsUrlForAffiliates(accountId, campaignId) {
    const url = `${this.#getBaseRTBUrl(accountId, campaignId)}` + '/url';
    return this.$http.get(url);
  }

  getBulkModifiers(accountId) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/rtb/bulk-modifiers`;
    return this.$http.get(url);
  }

  uploadBulkModifiers(accountId, file) {
    const url = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/rtb/bulk-modifiers/fromCsv?name=${file.name}`;
    const fd = new FormData();
    fd.append(file.name, file);
    return this.$http.put(url, fd, {
      headers: { 'Content-Type': undefined }
    });
  }

  pushSetupDynamicInboundCallsCampaignSettings(accountId, campaignId, campaignSettings) {
    const url = `${this.#getBaseRTBUrl(accountId, campaignId)}`;
    return this.$http.put(url, campaignSettings);
  }

  pushDynamicInboundCallsCampaignSettings(accountId, campaignId, campaignSettings) {
    const url = `${this.#getBaseRTBUrl(accountId, campaignId)}`;
    return this.$http.patch(url, campaignSettings);
  }

  pushDynamicInboundCallsPublisherSettings(accountId, campaignId, affiliateId, publisherSettings) {
    const url = `${this.#getBaseRTBPublisherUrl(accountId, campaignId, affiliateId)}`;
    return this.$http.patch(url, publisherSettings);
  }

  customScoringRequest(accountId, payload) {
    const url = `${this.#getProxyUrl(accountId)}`;
    return this.$http.post(url, payload);
  }

  #getBaseRTBPublisherUrl(accountId, campaignId, affiliateId) {
    const baseURL = `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/campaigns/${campaignId}/rtb/publishers`;
    return affiliateId ? `${baseURL}/${affiliateId}` : baseURL;
  }

  #getBaseRTBUrl(accountId, campaignId) {
    return `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/campaigns/${campaignId}/rtb`;
  }

  #getProxyUrl(accountId) {
    return `${this.ngAuthSettings.apiServiceBaseUri}${accountId}/HttpRequestTest`;
  }
}